import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production/lancements")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.LANCEMENTS.VIEW),
  component: () => <Outlet />,
});
